import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { PCIService } from 'src/app/Services/pci.service';
import { BookingGuestsService } from 'src/app/Services/booking-guests.service';
import { CruisepciService } from 'src/app/Services/cruisepci.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

@Component({
  selector: 'app-pcidata',
  templateUrl: './pcidata.component.html',
  styleUrls: ['./pcidata.component.css'],
})
export class PCIDataComponent {
  userdata?: UserData;
  rebcode: string | undefined;
  rebuid: number | undefined;
  OBPortalSvcURL = '';

  BookingGuestsInfo: any;
  bookingguestsdata: any;
  PCIInfo: any;
  PCIdata: any;

  eventCode: string | undefined;
  CruisePCIInfo: any;
  CruisePCIData: any;

  foliolist:
    | {
        FolioId: number;
      }[] = [];

  constructor(
    private appConfigService: AppConfigService,
    private PCIService: PCIService,
    private BookingGuestService: BookingGuestsService,
    private CruisePCIService: CruisepciService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.rebcode = this.userdata?.rebcode;
    this.getCruisePCIData();
  }
  getBookingGuests() {
    this.rebuid = this.userdata?.rebuid!;
    this.bookingguestsdata = this.BookingGuestService.GetBookingGuests(
      this.rebuid
    ).subscribe((bookingguestsdata) =>
      this.setBookingGuests(bookingguestsdata)
    );
  }
  setBookingGuests(resdata: any) {
    this.bookingguestsdata = resdata;
    if (this.bookingguestsdata.GetBookingGuests.Result.Status == 'A') {
      this.BookingGuestsInfo =
        this.bookingguestsdata.GetBookingGuests.BookingGuestList;
      this.getPCIData();
    }
  }
  getCruisePCIData() {
    this.eventCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.bookingguestsdata = this.CruisePCIService.GetCruisePCI(
      this.eventCode
    ).subscribe((CruisePCIData) => this.setCruisePCIData(CruisePCIData));
  }

  setCruisePCIData(resdata: any) {
    this.CruisePCIData = resdata;
    if (this.CruisePCIData.GetCruisePCI.Result.Status == 'A') {
      this.CruisePCIInfo = this.CruisePCIData.GetCruisePCI.CruisePCIList;
    }
  }

  getPCIData() {
    this.rebcode = this.userdata?.rebcode!;
    //  for (let iindex = 0; iindex < this.BookingGuestsInfo.length; iindex++) {
    var folio: {
      FolioId: number;
    };
    // folio = { FolioId: this.BookingGuestsInfo[iindex].refFolfolioId };
    folio = { FolioId: this.BookingGuestsInfo[0].refFolfolioId };
    this.foliolist.push(folio);
    //  }

    this.bookingguestsdata = this.PCIService.getPCIData(
      this.rebcode,
      this.foliolist
    ).subscribe((PCIdata) => this.setPCIData(PCIdata));
  }
  setPCIData(resdata: any) {
    this.PCIdata = resdata;
    if (this.PCIdata.GetPCIInfo.Result.Status == 'A') {
      this.PCIInfo = this.PCIdata.GetPCIInfo.PCIInfoList;
      this.PCIInfo = this.PCIInfo.filter(
        (PCIinfo: { itiType: any }) => PCIinfo.itiType === 'Cruise'
      );
    }
  }
}
